/**
 * Kho ảnh món dựng sẵn.
 *
 * Rào cản lớn nhất khi một quán đổi sang phần mềm mới là nhập 50 món bằng tay. App đã bớt
 * được phần tên và giá bằng cách chụp bảng giá; kho ảnh này bớt nốt phần còn lại: chủ quán
 * bấm một tấm ảnh, gõ giá, xong một món.
 *
 * Ảnh nằm trong `public/menu/`, đi kèm bản cài nên <b>mất mạng vẫn hiện</b>. Sản phẩm chỉ
 * lưu cái mã ngắn (`ca-phe-sua-da`), không lưu ảnh — nhờ vậy gói danh mục kéo về máy vẫn
 * nhẹ như trước, dù mỗi món đều có hình.
 *
 * Món hiếm không có trong kho thì chủ quán tự tải ảnh lên; khi đó mã bắt đầu bằng `u/`.
 */

export interface MenuImage {
  /** Mã lưu vào sản phẩm. Cũng là tên file trong `public/menu/`. */
  key: string
  name: string
  group: string
  /** Đơn vị hay dùng cho món này — điền sẵn để chủ quán khỏi chọn. */
  unit: string
}

export const MENU_IMAGES: MenuImage[] = [
  { key: 'ca-phe-sua-da', name: 'Cà phê sữa đá', group: 'Cà phê', unit: 'ly' },
  { key: 'ca-phe-den-da', name: 'Cà phê đen đá', group: 'Cà phê', unit: 'ly' },
  { key: 'ca-phe-nong', name: 'Cà phê nóng', group: 'Cà phê', unit: 'ly' },
  { key: 'ca-phe-muoi', name: 'Cà phê muối', group: 'Cà phê', unit: 'ly' },
  { key: 'ca-phe-da-xay', name: 'Cà phê đá xay', group: 'Cà phê', unit: 'ly' },
  { key: 'bac-xiu', name: 'Bạc xỉu', group: 'Cà phê', unit: 'ly' },
  { key: 'cappuccino', name: 'Cappuccino', group: 'Cà phê', unit: 'ly' },
  { key: 'latte', name: 'Latte', group: 'Cà phê', unit: 'ly' },
  { key: 'espresso', name: 'Espresso', group: 'Cà phê', unit: 'ly' },
  { key: 'cacao', name: 'Cacao', group: 'Cà phê', unit: 'ly' },

  { key: 'matcha-latte', name: 'Matcha latte', group: 'Trà & trà sữa', unit: 'ly' },
  { key: 'tra-sua-tran-chau', name: 'Trà sữa trân châu', group: 'Trà & trà sữa', unit: 'ly' },
  { key: 'tra-sua-thai', name: 'Trà sữa Thái', group: 'Trà & trà sữa', unit: 'ly' },
  { key: 'tra-dao', name: 'Trà đào', group: 'Trà & trà sữa', unit: 'ly' },
  { key: 'tra-chanh', name: 'Trà chanh', group: 'Trà & trà sữa', unit: 'ly' },
  { key: 'tra-vai', name: 'Trà vải', group: 'Trà & trà sữa', unit: 'ly' },
  { key: 'tra-atiso-do', name: 'Trà atisô đỏ', group: 'Trà & trà sữa', unit: 'ly' },
  { key: 'tra-dau-tam', name: 'Trà dâu tằm', group: 'Trà & trà sữa', unit: 'ly' },
  { key: 'tra-lipton-chanh', name: 'Trà lipton chanh', group: 'Trà & trà sữa', unit: 'ly' },
  { key: 'tra-gung', name: 'Trà gừng', group: 'Trà & trà sữa', unit: 'ly' },

  { key: 'sinh-to-xoai', name: 'Sinh tố xoài', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'sinh-to-dau', name: 'Sinh tố dâu', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'sinh-to-bo', name: 'Sinh tố bơ', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'sinh-to-sapoche', name: 'Sinh tố sapoche', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'sinh-to-chuoi', name: 'Sinh tố chuối', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'sinh-to-dua', name: 'Sinh tố dừa', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'sinh-to-trai-cay', name: 'Sinh tố trái cây', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'nuoc-ep-cam', name: 'Nước ép cam', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'nuoc-ep-tao', name: 'Nước ép táo', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'nuoc-ep-dua', name: 'Nước ép dứa', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'nuoc-ep-ca-rot', name: 'Nước ép cà rốt', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'nuoc-ep-oi', name: 'Nước ép ổi', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'nuoc-ep-dua-hau', name: 'Nước ép dưa hấu', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'nuoc-ep-chanh-day', name: 'Nước ép chanh dây', group: 'Nước ép & sinh tố', unit: 'ly' },
  { key: 'ep-cam-mat-ong', name: 'Ép cam mật ong', group: 'Nước ép & sinh tố', unit: 'ly' },

  { key: 'soda-chanh', name: 'Soda chanh', group: 'Nước giải khát', unit: 'ly' },
  { key: 'nuoc-mia', name: 'Nước mía', group: 'Nước giải khát', unit: 'ly' },
  { key: 'da-me', name: 'Đá me', group: 'Nước giải khát', unit: 'ly' },
  { key: 'da-chanh', name: 'Đá chanh', group: 'Nước giải khát', unit: 'ly' },
  { key: 'nuoc-tac', name: 'Nước tắc', group: 'Nước giải khát', unit: 'ly' },
  { key: 'chanh-nong', name: 'Chanh nóng', group: 'Nước giải khát', unit: 'ly' },
  { key: 'chanh-mat-ong', name: 'Chanh mật ong', group: 'Nước giải khát', unit: 'ly' },
  { key: 'nuoc-gung-nong', name: 'Nước gừng nóng', group: 'Nước giải khát', unit: 'ly' },
  { key: 'nuoc-gung-chanh', name: 'Nước gừng chanh', group: 'Nước giải khát', unit: 'ly' },
  { key: 'sua-dua-tuoi', name: 'Sữa dừa tươi', group: 'Nước giải khát', unit: 'ly' },
  { key: 'dua-tuoi', name: 'Nước dừa tươi', group: 'Nước giải khát', unit: 'trái' },

  { key: 'pho-bo', name: 'Phở bò', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'pho-ga', name: 'Phở gà', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'bun-bo-hue', name: 'Bún bò Huế', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'bun-thai', name: 'Bún Thái', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'bun-ca', name: 'Bún cá', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'bun-ca-soc-trang', name: 'Bún cá Sóc Trăng', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'bun-thit-nuong', name: 'Bún thịt nướng', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'bun-tom-nuong', name: 'Bún tôm nướng', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'bun-cha-gio', name: 'Bún chả giò', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'bun-cha-ha-noi', name: 'Bún chả Hà Nội', group: 'Bún, phở & mì', unit: 'phần' },
  { key: 'bun-dau-mam-tom', name: 'Bún đậu mắm tôm', group: 'Bún, phở & mì', unit: 'phần' },
  { key: 'hu-tieu', name: 'Hủ tiếu', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'hu-tieu-muc', name: 'Hủ tiếu mực', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'hu-tieu-ga', name: 'Hủ tiếu gà', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'hu-tieu-mi', name: 'Hủ tiếu mì', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'banh-canh', name: 'Bánh canh', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'banh-canh-hai-san', name: 'Bánh canh hải sản', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'banh-canh-cua', name: 'Bánh canh cua', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'hoanh-thanh', name: 'Hoành thánh', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'mi-hoanh-thanh', name: 'Mì hoành thánh', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'mi-kho', name: 'Mì khô', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'nui', name: 'Nui', group: 'Bún, phở & mì', unit: 'tô' },
  { key: 'mi-xao-bo', name: 'Mì xào bò', group: 'Bún, phở & mì', unit: 'dĩa' },
  { key: 'mi-xao-hai-san', name: 'Mì xào hải sản', group: 'Bún, phở & mì', unit: 'dĩa' },
  { key: 'mi-xao-ga', name: 'Mì xào gà', group: 'Bún, phở & mì', unit: 'dĩa' },
  { key: 'mi-y-sot-bo-bam', name: 'Mì Ý sốt bò bằm', group: 'Bún, phở & mì', unit: 'dĩa' },

  { key: 'com-trang', name: 'Cơm trắng', group: 'Món chính', unit: 'chén' },
  { key: 'com-tam', name: 'Cơm tấm sườn nướng', group: 'Món chính', unit: 'dĩa' },
  { key: 'com-tam-bi-cha', name: 'Cơm tấm bì chả', group: 'Món chính', unit: 'dĩa' },
  { key: 'com-ga-xoi-mo', name: 'Cơm gà xối mỡ', group: 'Món chính', unit: 'dĩa' },
  { key: 'com-ga-luoc', name: 'Cơm gà luộc', group: 'Món chính', unit: 'dĩa' },
  { key: 'com-ga-nuong', name: 'Cơm gà nướng', group: 'Món chính', unit: 'dĩa' },
  { key: 'com-bo-luc-lac', name: 'Cơm bò lúc lắc', group: 'Món chính', unit: 'dĩa' },
  { key: 'com-chien-hai-san', name: 'Cơm chiên hải sản', group: 'Món chính', unit: 'dĩa' },
  { key: 'com-chien-duong-chau', name: 'Cơm chiên dương châu', group: 'Món chính', unit: 'dĩa' },
  { key: 'com-chien-bo', name: 'Cơm chiên bò', group: 'Món chính', unit: 'dĩa' },
  { key: 'com-chien-toi', name: 'Cơm chiên tỏi', group: 'Món chính', unit: 'dĩa' },
  { key: 'com-chien-chay', name: 'Cơm chiên chay', group: 'Món chính', unit: 'dĩa' },
  { key: 'bo-xao-hanh-tay', name: 'Bò xào hành tây', group: 'Món chính', unit: 'dĩa' },
  { key: 'bo-bit-tet', name: 'Bò bít tết', group: 'Món chính', unit: 'phần' },
  { key: 'ga-xao-sa-ot', name: 'Gà xào sả ớt', group: 'Món chính', unit: 'dĩa' },
  { key: 'thit-kho-tau', name: 'Thịt kho tàu', group: 'Món chính', unit: 'dĩa' },
  { key: 'ca-kho-to', name: 'Cá kho tộ', group: 'Món chính', unit: 'tộ' },
  { key: 'ca-tim-kho-to', name: 'Cà tím kho tộ', group: 'Món chính', unit: 'tộ' },
  { key: 'ca-nuc-chien', name: 'Cá nục chiên', group: 'Món chính', unit: 'dĩa' },
  { key: 'oc-kho-tieu', name: 'Ốc kho tiêu', group: 'Món chính', unit: 'dĩa' },
  { key: 'vit-tiem-thuoc-bac', name: 'Vịt tiềm thuốc bắc', group: 'Món chính', unit: 'tộ' },

  { key: 'lau-thai', name: 'Lẩu Thái', group: 'Lẩu', unit: 'nồi' },
  { key: 'lau-mam', name: 'Lẩu mắm', group: 'Lẩu', unit: 'nồi' },
  { key: 'lau-rieu-cua', name: 'Lẩu riêu cua', group: 'Lẩu', unit: 'nồi' },
  { key: 'lau-ga-la-e', name: 'Lẩu gà lá é', group: 'Lẩu', unit: 'nồi' },

  { key: 'vu-de-nuong', name: 'Vú dê nướng', group: 'Món nhậu', unit: 'dĩa' },
  { key: 'vu-heo-nuong', name: 'Vú heo nướng', group: 'Món nhậu', unit: 'dĩa' },
  { key: 'nem-nuong-nha-trang', name: 'Nem nướng Nha Trang', group: 'Món nhậu', unit: 'phần' },
  { key: 'be-thui', name: 'Bê thui', group: 'Món nhậu', unit: 'dĩa' },
  { key: 'chan-ga-sa-tac', name: 'Chân gà sả tắc', group: 'Món nhậu', unit: 'dĩa' },
  { key: 'oc-hap-sa', name: 'Ốc hấp sả', group: 'Món nhậu', unit: 'dĩa' },
  { key: 'hen-xuc-banh-da', name: 'Hến xúc bánh đa', group: 'Món nhậu', unit: 'dĩa' },
  { key: 'goi-ga-xe-phay', name: 'Gỏi gà xé phay', group: 'Món nhậu', unit: 'dĩa' },
  { key: 'goi-xoai-kho-bo', name: 'Gỏi xoài khô bò', group: 'Món nhậu', unit: 'dĩa' },

  { key: 'canh-chua-ca-hu', name: 'Canh chua cá hú', group: 'Canh & súp', unit: 'tô' },
  { key: 'canh-chua-ca-tre', name: 'Canh chua cá trê', group: 'Canh & súp', unit: 'tô' },
  { key: 'canh-rau-cu-nau-suon', name: 'Canh rau củ nấu sườn', group: 'Canh & súp', unit: 'tô' },
  { key: 'sup-rau-cu', name: 'Súp rau củ', group: 'Canh & súp', unit: 'tô' },

  { key: 'canh-ga-chien-nuoc-mam', name: 'Cánh gà chiên nước mắm', group: 'Món chiên', unit: 'phần' },
  { key: 'canh-ga-chien-gion', name: 'Cánh gà chiên giòn', group: 'Món chiên', unit: 'phần' },
  { key: 'thit-heo-chien-xu', name: 'Thịt heo chiên xù', group: 'Món chiên', unit: 'phần' },
  { key: 'tom-chien-gion', name: 'Tôm chiên giòn', group: 'Món chiên', unit: 'phần' },
  { key: 'muc-chien-gion', name: 'Mực chiên giòn', group: 'Món chiên', unit: 'phần' },
  { key: 'ca-hu-chien-gion', name: 'Cá hú chiên giòn', group: 'Món chiên', unit: 'phần' },
  { key: 'dau-hu-chien-gion', name: 'Đậu hũ chiên giòn', group: 'Món chiên', unit: 'dĩa' },
  { key: 'cha-gio-chien', name: 'Chả giò chiên', group: 'Món chiên', unit: 'phần' },
  { key: 'khoai-tay-chien', name: 'Khoai tây chiên', group: 'Món chiên', unit: 'phần' },

  { key: 'banh-mi-thit', name: 'Bánh mì thịt', group: 'Ăn kèm', unit: 'ổ' },
  { key: 'sandwich', name: 'Sandwich', group: 'Ăn kèm', unit: 'phần' },
  { key: 'goi-cuon', name: 'Gỏi cuốn', group: 'Ăn kèm', unit: 'phần' },
  { key: 'goi-du-du-tom-thit', name: 'Gỏi đu đủ tôm thịt', group: 'Ăn kèm', unit: 'dĩa' },
  { key: 'banh-xeo', name: 'Bánh xèo', group: 'Ăn kèm', unit: 'cái' },
  { key: 'salad-ca-ngu', name: 'Salad cá ngừ', group: 'Ăn kèm', unit: 'phần' },
  { key: 'salad-rau-cu', name: 'Salad rau củ', group: 'Ăn kèm', unit: 'phần' },
  { key: 'trung-chien', name: 'Trứng chiên', group: 'Ăn kèm', unit: 'dĩa' },
  { key: 'rau-muong-xao-toi', name: 'Rau muống xào tỏi', group: 'Ăn kèm', unit: 'dĩa' },
  { key: 'rau-luoc-kho-quet', name: 'Rau luộc kho quẹt', group: 'Ăn kèm', unit: 'dĩa' },
  { key: 'dau-que-xao-tom', name: 'Đậu que xào tôm', group: 'Ăn kèm', unit: 'dĩa' },
  { key: 'dau-hu-sot-ca', name: 'Đậu hũ sốt cà', group: 'Ăn kèm', unit: 'dĩa' },

  { key: 'che-ba-mau', name: 'Chè ba màu', group: 'Chè & rau câu', unit: 'ly' },
  { key: 'che-khuc-bach', name: 'Chè khúc bạch', group: 'Chè & rau câu', unit: 'ly' },
  { key: 'che-thai', name: 'Chè Thái', group: 'Chè & rau câu', unit: 'ly' },
  { key: 'che-buoi', name: 'Chè bưởi', group: 'Chè & rau câu', unit: 'ly' },
  { key: 'che-dau-do', name: 'Chè đậu đỏ', group: 'Chè & rau câu', unit: 'ly' },
  { key: 'che-dau-den', name: 'Chè đậu đen', group: 'Chè & rau câu', unit: 'ly' },
  { key: 'rau-cau-dua', name: 'Rau câu dừa', group: 'Chè & rau câu', unit: 'phần' },
  { key: 'rau-cau-trai-cay', name: 'Rau câu trái cây', group: 'Chè & rau câu', unit: 'phần' },

  { key: 'banh-tiramisu', name: 'Bánh tiramisu', group: 'Tráng miệng', unit: 'cái' },
  { key: 'banh-cheesecake', name: 'Bánh cheesecake', group: 'Tráng miệng', unit: 'miếng' },
  { key: 'banh-mousse-chocolate', name: 'Bánh mousse chocolate', group: 'Tráng miệng', unit: 'cái' },
  { key: 'panna-cotta', name: 'Panna cotta', group: 'Tráng miệng', unit: 'ly' },
  { key: 'sua-chua-dau', name: 'Sữa chua dâu', group: 'Tráng miệng', unit: 'ly' },
  { key: 'sua-chua-chanh-day', name: 'Sữa chua chanh dây', group: 'Tráng miệng', unit: 'ly' },
  { key: 'sua-chua-trai-cay', name: 'Sữa chua trái cây', group: 'Tráng miệng', unit: 'ly' },
  { key: 'trai-cay-theo-mua', name: 'Trái cây theo mùa', group: 'Tráng miệng', unit: 'dĩa' },
  { key: 'banh-su-kem', name: 'Bánh su kem', group: 'Tráng miệng', unit: 'cái' },
  { key: 'mochi-kem', name: 'Mochi kem', group: 'Tráng miệng', unit: 'phần' },
  { key: 'creme-brulee', name: 'Crème brûlée', group: 'Tráng miệng', unit: 'ly' },
  { key: 'banh-flan', name: 'Bánh flan', group: 'Tráng miệng', unit: 'cái' },
  { key: 'kem-socola', name: 'Kem socola', group: 'Tráng miệng', unit: 'ly' },
  { key: 'kem-vani', name: 'Kem vani', group: 'Tráng miệng', unit: 'ly' },
  { key: 'kem-dau', name: 'Kem dâu', group: 'Tráng miệng', unit: 'ly' },
  { key: 'kem-matcha', name: 'Kem matcha', group: 'Tráng miệng', unit: 'ly' },
  { key: 'kem-viet-quoc', name: 'Kem việt quất', group: 'Tráng miệng', unit: 'ly' },
  { key: 'kem-bac-ha', name: 'Kem bạc hà', group: 'Tráng miệng', unit: 'ly' },
  { key: 'kem-cookies', name: 'Kem cookies', group: 'Tráng miệng', unit: 'ly' },
  { key: 'kem-sau-rieng', name: 'Kem sầu riêng', group: 'Tráng miệng', unit: 'ly' },
  { key: 'kem-thap-cam', name: 'Kem thập cẩm', group: 'Tráng miệng', unit: 'ly' },

  { key: 'mi-goi', name: 'Mì gói', group: 'Tạp hoá · Ăn vặt & nước', unit: 'gói' },
  { key: 'banh-snack', name: 'Bánh snack', group: 'Tạp hoá · Ăn vặt & nước', unit: 'gói' },
  { key: 'banh-quy', name: 'Bánh quy', group: 'Tạp hoá · Ăn vặt & nước', unit: 'hộp' },
  { key: 'keo-gum', name: 'Kẹo · Gum', group: 'Tạp hoá · Ăn vặt & nước', unit: 'gói' },
  { key: 'sua-hop', name: 'Sữa hộp', group: 'Tạp hoá · Ăn vặt & nước', unit: 'hộp' },
  { key: 'nuoc-ngot', name: 'Nước ngọt', group: 'Tạp hoá · Ăn vặt & nước', unit: 'chai' },
  { key: 'nuoc-suoi', name: 'Nước suối', group: 'Tạp hoá · Ăn vặt & nước', unit: 'chai' },
  { key: 'tra-dong-chai', name: 'Trà đóng chai', group: 'Tạp hoá · Ăn vặt & nước', unit: 'chai' },
  { key: 'nuoc-tang-luc', name: 'Nước tăng lực', group: 'Tạp hoá · Ăn vặt & nước', unit: 'lon' },
  { key: 'bia', name: 'Bia', group: 'Tạp hoá · Ăn vặt & nước', unit: 'lon' },
  { key: 'ca-phe-hoa-tan', name: 'Cà phê hoà tan', group: 'Tạp hoá · Ăn vặt & nước', unit: 'hộp' },
  { key: 'tra-tui-loc', name: 'Trà túi lọc', group: 'Tạp hoá · Ăn vặt & nước', unit: 'hộp' },

  { key: 'gia-vi-nuoc-cham', name: 'Gia vị · Nước chấm', group: 'Tạp hoá · Nấu ăn', unit: 'chai' },
  { key: 'dau-an', name: 'Dầu ăn', group: 'Tạp hoá · Nấu ăn', unit: 'chai' },
  { key: 'gao-duong', name: 'Gạo · Đường', group: 'Tạp hoá · Nấu ăn', unit: 'kg' },
  { key: 'sua-bot-ngu-coc', name: 'Sữa bột · Ngũ cốc', group: 'Tạp hoá · Nấu ăn', unit: 'hộp' },

  { key: 'my-pham-ca-nhan', name: 'Mỹ phẩm · Chăm sóc cá nhân', group: 'Tạp hoá · Gia dụng', unit: 'chai' },
  { key: 'nuoc-giat-rua-chen', name: 'Nước giặt · Nước rửa chén', group: 'Tạp hoá · Gia dụng', unit: 'chai' },
  { key: 'giay-ve-sinh', name: 'Giấy vệ sinh · Khăn giấy', group: 'Tạp hoá · Gia dụng', unit: 'lốc' },
  { key: 'pin-phu-kien', name: 'Pin · Phụ kiện điện tử', group: 'Tạp hoá · Gia dụng', unit: 'vỉ' },
  { key: 'do-gia-dung', name: 'Đồ gia dụng khác', group: 'Tạp hoá · Gia dụng', unit: 'cái' },
]

export const MENU_GROUPS = [...new Set(MENU_IMAGES.map((m) => m.group))]

const byKey = new Map(MENU_IMAGES.map((m) => [m.key, m]))

export const stockImage = (key: string | null | undefined): MenuImage | undefined =>
  key ? byKey.get(key) : undefined

/**
 * Đường dẫn ảnh của một mã.
 *
 * Ảnh dựng sẵn nằm cùng bản cài nên đi đường tương đối. Ảnh chủ quán tự tải lên nằm trên
 * máy chủ API — khác tên miền với app bán hàng, nên phải ghép đúng gốc của máy chủ ấy.
 */
export function imageUrl(key: string | null | undefined): string | null {
  if (!key) return null
  if (key.startsWith('u/')) {
    const base = import.meta.env.VITE_API_URL ?? ''
    return `${base}/uploads/products/${key.slice(2)}.jpg`
  }
  return byKey.has(key) ? `/menu/${key}.jpg` : null
}

/**
 * Đoán ảnh dựng sẵn cho một cái tên món.
 *
 * Dùng khi chụp bảng giá ra một loạt món: máy tự gắn ảnh cho món nào tên khớp, chủ quán
 * chỉ phải chọn tay những món còn lại. So sau khi bỏ dấu — người ta gõ "ca phe sua da"
 * cũng phải ra đúng món ấy.
 */
export function guessImage(name: string): string | null {
  const want = bare(name)
  if (!want) return null

  const exact = MENU_IMAGES.find((m) => bare(m.name) === want)
  if (exact) return exact.key

  // Khớp lỏng: tên món chứa trọn tên trong kho, hoặc ngược lại. "Cà phê sữa đá size L"
  // vẫn ra ảnh cà phê sữa đá.
  const loose = MENU_IMAGES.find((m) => want.includes(bare(m.name)) || bare(m.name).includes(want))
  return loose?.key ?? null
}

/** Bỏ dấu, gom khoảng trắng — để so tên tiếng Việt mà không bắt ai gõ đúng dấu. */
export const bare = (s: string) =>
  s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/gi, 'd')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
